import React from 'react';
import ProtectedRouteWrapper from './ProtectedRouteWrapper';

const ProtectedRoutesGroup = (store) => {
  return class extends React.Component {
    render() {
      return (
        <ProtectedRouteWrapper store={store}>
          {this.props.children}
        </ProtectedRouteWrapper>
      );
    }
  };
};

export default ProtectedRoutesGroup;
